import type { FormEvent, ReactNode } from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { DashboardCard2 } from "@/ui2/molecules/DashboardCard2";
import { Divider2 } from "@/ui2/atoms/Divider";

import { AssessmentCancelButton } from "./AssessmentCancelButton";

type FormLayoutProps = {
  cardClassName?: string;
  children: ReactNode;
  description: string;
  isDirty?: boolean;
  isSubmitting?: boolean;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  title: string;
};

export function FormLayout({
  cardClassName = "tw:md:max-w-188 tw:mx-auto tw:w-full",
  children,
  description,
  isDirty = false,
  isSubmitting = false,
  onSubmit,
  title,
}: FormLayoutProps) {
  return (
    <DashboardCard2
      className={cardClassName}
      classNameCopy="tw:md:pr-[25%]"
      copy={description}
      headingProps={{ size: 3 }}
      title={title}
    >
      <form className="tw:flex tw:flex-col tw:gap-6" onSubmit={onSubmit}>
        {children}

        <Divider2 className="tw:my-0!" />

        <div className="tw:flex tw:justify-end tw:gap-3">
          <AssessmentCancelButton isDirty={isDirty} isSubmitting={isSubmitting} />

          <Button2 className="tw:w-40" isLoading={isSubmitting} type="submit" variant="primary">
            Submit
          </Button2>
        </div>
      </form>
    </DashboardCard2>
  );
}
